import type { CartLine, ComponentizableCartLine } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";

import { getDiscountName } from "@repo/shopify/utils/order";

import Price from "@atoms/Price";

export default function CheckoutLineItem({ node }: { node: CartLine | ComponentizableCartLine }) {
  const compareAtPrice = parseFloat(node.cost.compareAtAmountPerQuantity?.amount || "0") * node.quantity;
  const price = parseFloat(node.cost.amountPerQuantity.amount) * node.quantity;
  const discountPrice = parseFloat(node.cost.totalAmount.amount);

  return (
    <React.Fragment key={node.id}>
      <div className="col-span-4">
        <span>{node.merchandise.product.title}</span>
        <span className="ml-1 font-normal">{node.merchandise.title.replace(" /", ",")}</span>
      </div>
      <span className="col-span-1 flex justify-end">{`Qty ${node.quantity}`}</span>

      <div className="col-span-3 flex flex-col items-end">
        <Price
          className="text-right"
          compareAtPrice={compareAtPrice ? compareAtPrice : price}
          direction="vertical"
          price={discountPrice}
          variant="secondary"
        />
        {node.discountAllocations.length ? (
          <>
            {node.discountAllocations.map((discount) => (
              <span className="text-xs font-normal capitalize" key={getDiscountName(discount)}>
                {getDiscountName(discount)}
              </span>
            ))}
          </>
        ) : null}
      </div>
    </React.Fragment>
  );
}
